import { render, staticRenderFns } from "./DeliveryBasises.vue?vue&type=template&id=1dba9a33&"
import script from "./DeliveryBasises.vue?vue&type=script&lang=js&"
export * from "./DeliveryBasises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports